module.exports = __webpack_public_path__ + "static/img/Tehnomarket.940b4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Tehnomarket.png
// module id = ijQI
// module chunks = 0